<template>
    <div class="car-nav">
        <div class="cat-nav-upper">
            <div is="CarTab"></div>
            <div is="ViewSwitch"></div>
            <div is="OrderbyCtn"></div>
        </div>
        <div class="car-filter-group"></div>
    </div>
</template>

<script>
    import CarTab from './CarNav/CarTab.vue';
    import OrderbyCtn from './CarNav/OrderbyCtn.vue';
    import ViewSwitch from './CarNav/ViewSwitch.vue';
    export default {
        data() {
            return {

            };
        },
        components: {
            CarTab,
            OrderbyCtn,
            ViewSwitch
        }
    };
</script>



// WEBPACK FOOTER //
// CarNav.vue?a3ead860